/* eslint-disable react-refresh/only-export-components */
import { createBrowserRouter, Outlet } from 'react-router-dom';
import AppLayout from '@/components/AppLayout';
import ProtectedRoute from '@/components/ProtectedRoute';
import RBACGuard from '@/components/RBACGuard';
import ModuleHost from '@/components/ModuleHost';
import ModuleErrorBoundary from '@/components/ModuleErrorBoundary';
import AdminErrorBoundary from '@/components/AdminErrorBoundary';
import AdminLayout from '@/components/AdminLayout';
import { SignInPage } from '@/pages/SignInPage';
import DashboardPage from '@/pages/DashboardPage';
import NotFoundPage from '@/pages/NotFoundPage';
import UserListPage from '@/pages/admin/UserListPage';
import CreateUserPage from '@/pages/admin/CreateUserPage';
import UserDetailPage from '@/pages/admin/UserDetailPage';

/**
 * Protected layout wrapper — checks auth then renders the app shell
 * with an Outlet for child routes.
 */
function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </ProtectedRoute>
  );
}

// Router config — not a component module, safe to export non-components.
export const router = createBrowserRouter([
  // Public routes
  {
    path: '/sign-in',
    element: <SignInPage />,
  },

  // Protected routes — wrapped in auth guard + layout
  {
    element: <ProtectedLayout />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      // Admin Console — wrapped in RBACGuard + error boundary + consistent header
      {
        path: 'admin',
        element: (
          <AdminErrorBoundary>
            <RBACGuard requiredRole="admin">
              <AdminLayout />
            </RBACGuard>
          </AdminErrorBoundary>
        ),
        children: [
          { index: true, element: <UserListPage /> },
          { path: 'users/new', element: <CreateUserPage /> },
          { path: 'users/:userId', element: <UserDetailPage /> },
        ],
      },
      // Dynamic module route — ModuleHost handles lookup, RBAC, and embedding
      {
        path: 'modules/:moduleId',
        element: (
          <ModuleErrorBoundary moduleId="dynamic">
            <ModuleHost />
          </ModuleErrorBoundary>
        ),
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);
